import { registerThemePropertiesLoader } from "@ui5/webcomponents-base/dist/asset-registries/Themes.js";
import defaultThemeBase from "@ui5/webcomponents-theming/dist/generated/themes/sap_fiori_3/parameters-bundle.css.js";
import defaultTheme from "./sap_fiori_3/parameters-bundle.css.js";
registerThemePropertiesLoader("@ui5/webcomponents-theming", "sap_fiori_3", async () => defaultThemeBase);
registerThemePropertiesLoader("@ui5/webcomponents", "sap_fiori_3", async () => defaultTheme);
const styleData = { packageName: "@ui5/webcomponents", fileName: "themes/Popup.css", content: ":host{min-width:1px;display:none;position:fixed}" };
export default styleData;
//# sourceMappingURL=Popup.css.js.map